import StarsRenderer from './stars-renderer';
import {
  PRODUCT_RATING_CONTAINER,
  PRODUCT_RATING_COUNT,
  PRODUCT_RATING_STARS
} from '../classnames/reviews';
import { HIDDEN } from '../classnames/design-system';

export default class ProductRatingRenderer {
  starsRenderer = new StarsRenderer();

  render = (productIds, rating, count) => {
    const allContainers = productIds.reduce((accum, id) => {
      const containers = this.getStarsContainers(id);

      return [...accum, ...containers];
    }, []);

    allContainers.forEach((container) => {
      this.hide(container, count);
      this.renderStars(container, rating);
      this.renderTotal(container, count);
    });
  };

  hide = (container, count) => {
    const parent = container.parentElement;

    if (Number(count === 0)) {
      parent.classList.add(HIDDEN);
    }
  };

  renderTotal = (container, count) => {
    const totalWrapper = container.querySelector(`.${PRODUCT_RATING_COUNT}`);
    const { isFullLabel } = totalWrapper?.dataset || {};

    if (totalWrapper) {
      totalWrapper.innerHTML = isFullLabel
        ? `${count} Reviews`
        : `(${count})`;
    }
  };

  renderStars = (container, rating) => {
    const starsWrapper = container.querySelector(`.${PRODUCT_RATING_STARS}`);

    this.starsRenderer.render(starsWrapper, rating);
  };

  getStarsContainers =
    (productId) => document.querySelectorAll(`.${PRODUCT_RATING_CONTAINER}[data-product-id="${productId}"]`);
}
